// extracted by mini-css-extract-plugin
export default {"navigation":"yFpkSy83FpEvr673_VJ_","navigationTab":"WDiNzddY4e6DNamj8HY3","active":"Hbe9daaQz89YvrT4aRgP"};